export default __webpack_public_path__ + "static/How Can An Old Mattress Affect Your Sleep-3207497c345bdf2f885d9315bb077df5.jpg";